var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-checkbox",class:{ disabled: _vm.disabled },on:{"click":_vm.onClick}},[_c('div',{staticClass:"point",class:[_vm.innerChecked ? _vm.icon : '', { checked: _vm.innerChecked }]}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eab59e7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-components/~/ui-checkbox/src/ui-checkbox.vue
// module id = 661
// module chunks = 0